import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/login/Login.jsx";

import Admin from "./pages/Admin/Admin.jsx";
import Archives from "./pages/Admin/Archive.jsx";
import GestionMateriel from "./pages/GestionMateriel/GestionMateriel.jsx";
import ArchivesPrets from "./pages/GestionMateriel/ArchivesPrets.jsx";
import Rma from "./pages/RMA/RMA.jsx";
import ArchivesRma from "./pages/RMA/ArchiveRMA.jsx";
import SuiviClient from "./pages/SuiviClient/SuiviClient.jsx";
const Router = () => {
    const isAdmin = localStorage.getItem("isAdmin") === "true";

    return (
        <Routes>

            {/* Redirection */}
            <Route path="/" element={<Navigate to="/login" />} />

            {/* Login */}
            <Route path="/login" element={<Login />} />
            <Route path="/s/:token" element={<SuiviClient />} />
            <Route path="/admin/archives" element={isAdmin ? <Archives /> : <Navigate to="/login" />} />

            {/* Pages admin protégées */}
            <Route
                path="/suivi"
                element={isAdmin ? <Admin /> : <Navigate to="/login" />}
            />
            <Route
                path="/gestionmateriel"
                element={isAdmin ? <GestionMateriel /> : <Navigate to="/login" />}
            />
            <Route
                path="/rma"
                element={isAdmin ? <Rma /> : <Navigate to="/login" />}
            />
            <Route
                path="/rma/archives"
                element={isAdmin ? <ArchivesRma /> : <Navigate to="/login" />}
            />
            <Route
                path="/gestionmateriel/archives"
                element={isAdmin ? <ArchivesPrets /> : <Navigate to="/login" />}
            />
        </Routes>
    );
};

export default Router;
